
<cwo-expandable-component (isExpanded)="handleExpansion($event)" [headerStyle]="'fullWidth'" [overflowVisible]="expanded" [expandedInput]="expanded"
    [ariaControlsName]="choice().name" [id]="choiceExpandableId()"
    [ngStyle]="{'scroll-margin-top': scrollMarginTop + 'px'}"
    [style.--expand-duration]="'0.3s'"
>
    <ng-template #heading>
        <div class="header">
            <div class="header-pills-wrapper">
                <div class="header-wrapper">
                    <cwo-icon [name]="iconNameType.arrow" class="icon"
                        [ngStyle]="{transform: expanded ? 'rotate(0deg)' : 'rotate(-90deg)'}" />
                    <span class="label" [class.required]="(choiceValidator && choiceValidator.minIngredients && choiceValidator.minIngredients > choiceValidator.currentIngredients) || (choiceValidator && choiceValidator.exactIngredients && choiceValidator.exactIngredients > choiceValidator.currentIngredients)">{{choice().name}} </span>
                </div>
                @if(choiceValidator && choiceValidator.minIngredients && choiceValidator.minIngredients > choiceValidator.currentIngredients){
                <div class="notification-pill-wrapper neutural" [ngClass]="{'error' : toggleWarningsAfterSubmission() }">
                    <span class="notification-pill-label">
                        @if(toggleWarningsAfterSubmission()){
                        <span class="icon-wrapper">!</span>
                        }
                        {{'shared_components.choices.choice.required' | transloco}}
                    </span>
                </div>
                }@else if(choiceValidator && choiceValidator.exactIngredients && choiceValidator.exactIngredients > choiceValidator.currentIngredients){
                <div class="notification-pill-wrapper neutural" [ngClass]="{'error' : toggleWarningsAfterSubmission()}">
                    <span class="notification-pill-label">
                        @if(toggleWarningsAfterSubmission()){
                        <span class="icon-wrapper">!</span>
                        }
                        {{'shared_components.choices.choice.required' | transloco}}
                    </span>
                </div>
                }
            </div>
            <div #warningMessageElement [ngStyle]="{'scroll-margin-top': scrollMarginTopWarning + 'px'}">
                @if(choiceValidator && choiceValidator.longMessage && expanded){
                <div class="notification-wrapper">
                    <span class="notification-label" [ngClass]="{'bouncing-text' : bouncingTextToggle}">{{
                        choiceValidator.longMessage}}</span>
                </div>
                }
            </div>
        </div>
    </ng-template>
    <ng-template #content>
        <div class="content-wrapper" [id]="choiceExpandableId() + 'content'" [ngStyle]="{'gap': choice().groups.length ? '0.5rem' : '0.25rem'}">
            @if(choice().groups.length > 0) {
                @for (group of filteredIngredientsByGroup(); track $index) {
                    <cwo-ingredient-group [groupName]="group.choiceGroup">
                        <ng-template #ingredientsList>
                            @for (ingredient of group.filteredIngredients; track $index) {
                                @if(group.ingredients.includes(ingredient.name)){
                                    <cwo-dependable-ingredient 
                                        [isSpecial]="isSpecial()"
                                        [ingredient]="ingredient" 
                                        [choice]="choice()" 
                                        [orderedItem]="orderedItem()"
                                        [orderableItem]="orderableItem()"
                                        [index]="$index"
                                        [orderedChoice]="orderedChoice()"
                                        [ingredientTooltipVisible]="ingredientTooltipVisible === ingredient.name"
                                        (ingredientAdded)="onIngredientAdded(ingredient)"
                                        (setMessage)="setWarningMessage($event)" 
                                        (updatedSpecialItem)="updateSpecialItem.emit($event)"
                                    />
                                }

                            }
                        </ng-template>
                    </cwo-ingredient-group>
                }
            } @else {
                @for (ingredient of choice().ingredients; track $index) {
                    <cwo-dependable-ingredient 
                        [isSpecial]="isSpecial()"
                        [ingredient]="ingredient" 
                        [choice]="choice()" 
                        [orderedItem]="orderedItem()"
                        [orderableItem]="orderableItem()"
                        [index]="$index"
                        [orderedChoice]="orderedChoice()"
                        [ingredientTooltipVisible]="ingredientTooltipVisible === ingredient.name"
                        (ingredientAdded)="onIngredientAdded(ingredient)"
                        (setMessage)="setWarningMessage($event)" 
                        (updatedSpecialItem)="updateSpecialItem.emit($event)"
                    />
                }
            }
            
        </div>
    </ng-template>
</cwo-expandable-component>